export const kDefaultReminderTime = 21
export const kMinWordsForReflection = 20

export const kDefaultPersonalizationId = 'rosebud'
